<template>
  <div
    class="
      min-h-[calc(100vh-200.25px)]
      flex flex-row
      justify-center
      items-center
    "
  >
    <div class="mt-16 py-6 w-4/5 max-w-[1200px]">
      <div class="pro-card">
        <div class="pro-card">
          <div class="screen-header-right">
            <div class="screen-header-ellipsis"></div>
            <div class="screen-header-ellipsis"></div>
            <div class="screen-header-ellipsis"></div>
          </div>
        </div>
        <div class="wrappe g-glossy">
          <div class="screen-body">
            <div class="screen-body-item left">
              <div class="app-title">
                <p>Contact me</p>
                <div class="flex row justify-left my-3">
                  <a
                    class="mx-2"
                    height="40"
                    width="40"
                    target="blank"
                    href="https://www.linkedin.com/in/adnan-kreiker/"
                    ><img class="swing my-1" src="/linkedin.9e3927c.svg" alt=""
                  /></a>
                  <a
                    class="mx-2"
                    target="blank"
                    height="40"
                    width="40"
                    href="https://github.com/Adnan-kreiker"
                    ><img class="swing my-1" src="/github.2536ea4.svg" alt=""
                  /></a>
                  <img
                    class="email swing my-1 mx-2"
                    src="/outlook2.svg"
                    alt=""
                    height="40"
                    width="40"
                    @click="showEmail = !showEmail"
                  />
                </div>
              </div>
              <div>
                <p
                  v-if="showEmail"
                  data-aos="zoom-in-right"
                  data-aos-id="super-duper"
                  class="my-email"
                >
                  adnankreiker@hotmail.com
                </p>
              </div>
            </div>
            <div class="screen-body-item">
              <form
                name="contact"
                method="POST"
                data-netlify="true"
                netlify
                action="/success"
                netlify-honeypot="bot-field"
              >
                <input type="hidden" name="form-name" value="contact" />
                <div class="app-form">
                  <div class="app-form-group">
                    <input
                      id="name"
                      type="text"
                      name="name"
                      required
                      class="app-form-control"
                      placeholder="NAME"
                    />
                  </div>
                  <div class="app-form-group">
                    <input
                      id="email"
                      type="email"
                      required
                      name="email"
                      class="app-form-control"
                      placeholder="EMAIL"
                    />
                  </div>
                  <div class="app-form-group message">
                    <textarea
                      id="message"
                      name="message"
                      required
                      rows="7"
                      class="app-form-control"
                      placeholder="MESSAGE"
                    ></textarea>
                  </div>
                  <button class="sub-btn" type="submit">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showEmail: false,
    }
  },
}
</script>

<style lang="scss" scoped>
button {
  display: block;
  width: 200px;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-decoration: none;
  // background: #333333 !important;
  // padding: 20px 40px;
  text-align: center;
  border-radius: 20px;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: 3px solid #333;
  transition: all 0.35s;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.email {
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.wrapper {
  display: grid;
}
body,
button,
input,
textarea,
.app-button {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  letter-spacing: 1.2px;
}

.screen {
  position: relative;
  // background: #3e3e3e;
  border-radius: 15px;
}

.screen:after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 20px;
  right: 20px;
  bottom: 0;
  border-radius: 15px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  z-index: -1;
}

.screen-header {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: #4d4d4f;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.screen-header-left {
  margin-right: auto;
}

.screen-header-right {
  display: flex;
}

.screen-header-ellipsis {
  width: 3px;
  height: 3px;
  margin-left: 2px;
  border-radius: 8px;
  background: #999;
}

.screen-body {
  display: flex;
}

.screen-body-item {
  flex: 1;
  padding: 50px;
}

.screen-body-item.left {
  display: flex;
  flex-direction: column;
}

.app-title {
  // display: flex;
  // flex-direction: column;
  position: relative;
  color: #ffffff;
  font-size: 26px;
}

.app-contact {
  margin-top: auto;
  font-size: 8px;
  color: rgb(223, 223, 223);
}

.app-form-group {
  margin-bottom: 15px;
}

.app-form-group.message {
  margin-top: 40px;
}

.app-button {
  margin-bottom: 0;
  float: right;
}

.app-form-control {
  width: 100%;
  padding: 10px 0;
  background: none;
  border: none;
  border-bottom: 1px solid #666;
  color: rgb(255, 253, 253);
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.app-form-control::placeholder {
  color: rgb(255, 255, 255);
}

.app-form-control:focus {
  border-bottom-color: #ddd;
}

.app-form-button:hover {
  color: #ffffff;
}

@media screen and (max-width: 600px) {
  .screen-body {
    flex-direction: column;
  }

  .screen-body-item.left {
    margin-bottom: 30px;
  }

  .app-title {
    flex-direction: row;
  }

  .app-title span {
    margin-right: 12px;
  }

  .app-title:after {
    display: none;
  }
}

@media screen and (max-width: 600px) {
  .screen-body {
    padding: 40px;
  }

  .screen-body-item {
    padding: 0;
  }
}
@-webkit-keyframes swing {
  15% {
    -webkit-transform: translateY(4px);
    transform: translateY(4px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  50% {
    -webkit-transform: translateY(3px);
    transform: translateY(3px);
  }
  65% {
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
  }
  80% {
    -webkit-transform: translateY(2px);
    transform: translateY(2px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
@keyframes swing {
  15% {
    -webkit-transform: translateY(4px);
    transform: translateY(4px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  50% {
    -webkit-transform: translateY(3px);
    transform: translateY(3px);
  }
  65% {
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
  }
  80% {
    -webkit-transform: translateY(2px);
    transform: translateY(2px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
.swing:hover {
  -webkit-animation: swing 1s ease;
  animation: swing 1s ease;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  border-radius: 100%;
  border: 1px solid rgba(190, 16, 172, 1);
}
@media (min-width: 500px) {
  p {
    opacity: 1;
    font-size: 1.4rem;
  }
  .my-email {
    // margin-left: 60px;
    font-size: clamp(0.6rem, 3vw, 0.8rem);
  }
}
// @media (min-width: 500px) {
//   .my-email {
//     // margin-left: 60px;
//     font-size: 1rem;
//   }
// }
</style>
